import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class DeviceConsumablePricingItem extends PricingItem {
    public device?: Article;
    public consumable?: Article;
    public consumableExtraPrice?: string;
    public specificities?: Record<string, any>;
    public franchise?: any;
    public discount?: string;

}
